export const Role = {
  SUPPER_ADMIN: "ROLE_SUPPER_ADMIN",
  ADMIN: "ROLE_ADMIN",
  CSO: "ROLE_CSO",
  TEACHER: "ROLE_TEACHER",
  LXO: "ROLE_LXO",
  LX: "ROLE_LX",
  MKT: "ROLE_MKT",
  SALE: "ROLE_SALE",
  CENTER_ADMIN: "ROLE_CENTER_ADMIN",
  FINANCE: "ROLE_FINANCE",
  PROCUREMENT: "ROLE_PROCUREMENT",
  REQUESTER: "ROLE_REQUESTER",
  PROCUREMENT_MANAGER: "ROLE_PROCUREMENT_MANAGER",
  AE: "ROLE_AE",
  CORP: "ROLE_CORP",
  MANAGEMENT: "ROLE_MANAGEMENT",
  CALL_CENTRE: "ROLE_CALL_CENTRE",
  CDFM: "ROLE_CDFM",
  CENTRE_MANAGER: "ROLE_CENTRE_MANAGER",
  HSE: "ROLE_HSE",
  IT: "ROLE_IT",
  LEGAL: "ROLE_LEGAL",
  TALENT_DEVELOPMENT: "ROLE_TALENT_DEVELOPMENT",
  TEACHER_TRAINING: "ROLE_TEACHER_TRAINING",
  PROCUREMENT_STAFF: "ROLE_PROCUREMENT_STAFF",
  EC_SM: "ROLE_EC_SM",
  // Payment Request (PR) module — approve/reject/info-request still goes
  // through the shared Approval Rule Engine (see procurementPayments.js), not
  // a bespoke check on this role. Screens are mounted under the Procurement
  // Manager workspace (see routes.js `procurementManagerRoutes`) until this
  // role gets its own menu entry.
  PAYMENT_REQUEST: "ROLE_PAYMENT_REQUEST",
}

export const RoleLabel = {
  [Role.SUPPER_ADMIN]: "Super Admin",
  [Role.ADMIN]: "Admin",
  [Role.CSO]: "CSO",
  [Role.TEACHER]: "Teacher",
  [Role.LXO]: "Learning Experience Officer",
  [Role.LX]: "Learning Experience",
  [Role.MKT]: "Marketing",
  [Role.SALE]: "Sales",
  [Role.CENTER_ADMIN]: "Center Admin",
  [Role.FINANCE]: "Finance",
  [Role.PROCUREMENT]: "Procurement",
  [Role.REQUESTER]: "Requester",
  [Role.PROCUREMENT_MANAGER]: "Procurement Manager",
  [Role.AE]: "Apollonian Experience",
  [Role.CORP]: "Corporate Communication",
  [Role.MANAGEMENT]: "Management",
  [Role.CALL_CENTRE]: "Call Centre",
  [Role.CDFM]: "CDFM",
  [Role.CENTRE_MANAGER]: "Centre Manager",
  [Role.HSE]: "HSE",
  [Role.IT]: "Information Technology",
  [Role.LEGAL]: "Legal",
  [Role.TALENT_DEVELOPMENT]: "Talent Development",
  [Role.TEACHER_TRAINING]: "Teacher Training",
  [Role.PROCUREMENT_STAFF]: "Procurement Staff",
  [Role.EC_SM]: "EC SM",
  [Role.PAYMENT_REQUEST]: "Payment Request",
}

export const ListRole = Object.entries(RoleLabel).map(([value, label]) => ({
  label,
  value,
}))

export const RoleByLabel = Object.entries(RoleLabel).reduce(
  (acc, [code, label]) => {
    acc[label] = code
    return acc
  },
  {}
)

export const getRoleCode = (role) => {
  if (!role) return null
  if (Object.values(Role).includes(role)) return role
  return RoleByLabel[role] || null
}

export const isRole = (role, roleCode) => {
  const normalized = getRoleCode(role)
  return normalized === roleCode
}

export const hasAnyRole = (role, roleCodes = []) => {
  const normalized = getRoleCode(role)
  return roleCodes.includes(normalized)
}
